import React, { useState, useEffect, useContext, useRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import LeadDetail from "../../../components/sales/leadDetails/createLeadDetail/leadDetail";
import PostsaleDetail from "../../../components/sales/leadDetails/postsaleDetail/postsaleLeadType";
import FileUpload from "components/sales/fileUpload/fileUpload";
import {toast } from "react-toastify";
import { useHistory } from 'react-router-dom';
import { buildInvoiceConfirmDetails } from '../utils/invoiceConfirmDetails';

const VALET_SOLUTION_TYPE = 3;
const VALET_TEAM_ID = 21;

const ApprovalList = ({
  documentUploadUrlPublic,  
  approvalList,
  getApprovalList,
  acceptApproval,
  rejectApproval,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  getContractDetails,
  viewDetails,
  saveAllContractLogs,
  saveModificationLog,
  getSearchUser,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [viewContract, setViewContract] = useState(false)
  const [leadType, setLeadType] = useState(0)
  const [modificationModal, setModificationModal] = useState(false);
  const [contractId, setContractId] = useState(null);
  const modificationInputs = {
    remark: "",
    attachment: "",
  };
  const [formData, setFormData] = useState(modificationInputs);
  const [ownershipUserId, setOwnershipUserId] = useState(null);
  const [ownershipUserName, setOwnershipUserName] = useState('');
  const [valetUsers, setValetUsers] = useState([]);
  const [ownershipSelectKey, setOwnershipSelectKey] = useState(0);
  const [showAcceptConfirm, setShowAcceptConfirm] = useState(false);
  const acceptInFlightRef = useRef(false);


  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);
  const history = useHistory();

  const solutionType =
    viewDetails?.postsale_data?.commercial?.solution_type ??
    viewDetails?.postsale_data?.commercial?.solutionType ??
    null;
  const isValetContract = Number(solutionType) === VALET_SOLUTION_TYPE;

  const commercial = viewDetails?.postsale_data?.commercial ?? {};
  const invoiceOwnerName =
    commercial?.ownership_user_name ||
    commercial?.created_by_name ||
    '';
  const valetL1Name = commercial?.created_by_name || '';
  const valetL2Name = ownershipUserName || '';
  const installationPersonName =
    viewDetails?.postsale_data?.installation_person_name || '';
  const invoiceConfirmDetails = buildInvoiceConfirmDetails(
    viewDetails?.postsale_data
  );

  const resolveApprovalRow = (actionObj) => {
    const rows = approvalList?.resultSets;
    if (!Array.isArray(rows) || !actionObj) {
      return actionObj || {};
    }
    return (
      rows.find(
        (row) =>
          String(row.id) === String(actionObj.id) &&
          (actionObj.comm_id == null ||
            String(row.comm_id) === String(actionObj.comm_id))
      ) || actionObj
    );
  };

  const headerBtns = () => {
    return (
        <Fragment>
          <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt="" />
            {localization.showFilters}
          </Button>
        </Fragment>
    );
  };

  useEffect(() => {
    if (getApprovalList !== null) {
      (async () => {
        setIsLoading(true);
        await getApprovalList(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getApprovalList]);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem('viewDetail') !== 'undefined') {
        const leadTypeId =
            (await JSON.parse(localStorage.getItem('viewDetail'))) &&
            JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type_id;
          setLeadType(leadTypeId)
      }
    })();
  }, []);

  const Headers = [
    'Lead Number',
    'Contract No',
    'Client Name',
    'Lead Category',
    'Assigned To',
    'Zone',
    'Area',
    'Requested On',
    'Send Back',
    'Approve/Reject',
    'Action',
  ];


  useEffect(() => {
    const tableData = [
      'id',
      'lead_no',
      'comm_id',
      'client_name',
      'lead_category',
      'assigned_to',
      'zone',
      'area',
      'contract_creation_date',
      'Send Back',
      'modification_status'
    ];
  
    if (approvalList !== 'undefined' && approvalList !== {} && approvalList.resultSets) {
      const data = approvalList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          (() => {
            let actionData = {};
  
            if (element.project_status_id == 1) {
              if (element.lead_type_id == 1) {
                if(element.modification_status == 1) {
                actionData = {
                  'Approve/Reject': (element?.modification_status && element?.modification_status == 1) ? 'No' : '',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id }
                  ]
                };
              } else {
                actionData = {
                  'Approve/Reject': (element?.modification_status && element?.modification_status == 1) ? 'No' : '',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
                  ]
                };
              }
              } else if (element.lead_type_id == 2) {
                if(element.modification_status == 1) {
                  actionData = {
                    'Approve/Reject': 'No',
                    Action: [
                      { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                      // { name: 'Edit Contract', link: '/dashboard/edit-contract-apt/' + element.comm_id }
                    ]
                  };
                } else {
                actionData = {
                  'Approve/Reject': '',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    // { name: 'Edit Contract', link: '/dashboard/edit-contract-apt/' + element.comm_id }
                    { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
                  ]
                };
              }
              } else {
                actionData = {
                  'Approve/Reject': '',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    // { name: 'Edit Contract', link: '/dashboard/edit-contract-supply/' + element.comm_id }
                    { name: 'Edit Contract', link: '/dashboard/edit-contract-corporate-v2/' + element.comm_id }
                  ]
                };
              }
            } else {
              if (element.lead_type_id == 1) {
                actionData = {
                  'modification_status': -1,
                  status: 'Project Pending',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    // { name: 'Edit Contract', link: '/dashboard/edit-contract-corp/' + element.comm_id }
                  ]
                };
              } else if (element.lead_type_id == 2) {
                actionData = {
                  'modification_status': -1,
                  status: 'Project Pending',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    // { name: 'Edit Contract', link: '/dashboard/edit-contract-apt/' + element.comm_id }
                  ]
                };
              } else {
                actionData = {
                  // 'modification_status': -1,
                  status: 'Project Pending',
                  Action: [
                    { name: 'View Details', link: '/dashboard/contract-details/' + element.comm_id },
                    // { name: 'Edit Contract', link: '/dashboard/edit-contract-supply/' + element.comm_id }
                  ]
                };
              }
            }
            return actionData;
          })()
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);
  


  const updateApproval = async (data) => {
    setActionData(data);
    if (data.action === 'accept') {
      if (isValetContract && !ownershipUserId) {
        toast.error('Please select ownership user');
        return;
      }
      setViewContract(false);
      setShowAcceptConfirm(true);
    } else {
      setViewContract(false)
      setIsModal(true);
      setIsLoading(false);
    }
  };

  const confirmAcceptApproval = async () => {
    if (!actionData?.actionObj || acceptInFlightRef.current) {
      return;
    }
    if (isValetContract && !ownershipUserId) {
      toast.error('Please select ownership user');
      return;
    }
    acceptInFlightRef.current = true;
    const fullRow = resolveApprovalRow(actionData.actionObj);
    const requestData = {
      lead_id: fullRow?.id ?? actionData.actionObj.id,
      comm_id: fullRow?.comm_id ?? actionData.actionObj.comm_id,
      remarks: '',
    };
    if (isValetContract && ownershipUserId) {
      requestData.ownership_user_id = ownershipUserId;
    }

    setIsLoading(true);
    setShowAcceptConfirm(false);
    setViewContract(false);
    try {
      const response = await acceptApproval(requestData);
      if (response) {
        await getApprovalList(null, 1);
        setIsModal(true);
        setOwnershipUserId(null);
        setOwnershipUserName('');
        setValetUsers([]);
      }
    } finally {
      acceptInFlightRef.current = false;
      setIsLoading(false);
    }
  };

  const handleView = async (data) => {
    setActionData(data);
    setOwnershipUserId(null);
    setOwnershipUserName('');
    setShowAcceptConfirm(false);
    setValetUsers([]);
    setOwnershipSelectKey((k) => k + 1);
    const fullRow = resolveApprovalRow(data?.actionObj);
    const rowLeadType = fullRow?.lead_type_id ?? leadType;
    if (fullRow && Object.keys(fullRow).length) {
      localStorage.setItem('viewDetail', JSON.stringify([fullRow]));
      if (
        rowLeadType !== undefined &&
        rowLeadType !== null &&
        rowLeadType !== '' &&
        String(rowLeadType) !== 'undefined'
      ) {
        setLeadType(rowLeadType);
      }
    }
    setViewContract(true);
    const requestData = {
      lead_id: fullRow?.id ?? data?.actionObj?.id,
      commId: fullRow?.comm_id ?? data?.actionObj?.comm_id,
    };
    if (
      rowLeadType !== undefined &&
      rowLeadType !== null &&
      rowLeadType !== '' &&
      String(rowLeadType) !== 'undefined'
    ) {
      requestData.lead_type = rowLeadType;
    }
    setIsLoading(true);
    await getContractDetails(requestData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (!viewContract || !viewDetails || Object.keys(viewDetails).length === 0) {
      return;
    }
    const st =
      viewDetails?.postsale_data?.commercial?.solution_type ??
      viewDetails?.postsale_data?.commercial?.solutionType;
    if (Number(st) !== VALET_SOLUTION_TYPE || !getSearchUser) {
      return;
    }
    let cancelled = false;
    (async () => {
      const list = await getSearchUser('', { teamId: VALET_TEAM_ID });
      if (!cancelled) {
        setValetUsers(Array.isArray(list) ? list : []);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [viewContract, viewDetails, getSearchUser]);

  const handleContinue = async () => {
    setIsModal(false);
    const requestData = {
      lead_id: actionData.actionObj.id,
      comm_id: actionData.actionObj.comm_id,
      remarks: remarks.remarks,
    };
    setIsLoading(true);
    await rejectApproval(requestData).then(async (response) => {
      setIsLoading(false);
      if (response) {
        await getApprovalList(null, 1);
        setIsSuccessModel(true);
      }
    });
  };
  const handleModalHide = () => setIsModal(false);
  const handleRejectModalHide = () => setIsSuccessModel(false);
  const handleApprovalViewHide = () => {
    setViewContract(false);
    setShowAcceptConfirm(false);
    setOwnershipUserId(null);
    setOwnershipUserName('');
    setValetUsers([]);
  };

  const successIconBox = (text, func) => {
    return (
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{text}</h5>
          <Link to="#" onClick={func} className="btn btn-transparent">
            {localization.returnToApproval}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
    );
  };


  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getApprovalList(filter, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(3);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getApprovalList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  const handleSendBackModalHide = () => setModificationModal(false);

  const handleSendBack = (id) => {
    setContractId(id)
    setModificationModal(true);
  };

  const handleSubmit = async () => {
    const modificationData = {
      contract_id: contractId,
      remark: formData.remark,
      attachment: formData.attachment
    }
    setIsLoading(true);
    const res = await saveAllContractLogs(modificationData);
    if(res) {
      toast.success('Contract successfully send back for modification')
    } else {
      toast.error('Something went wrong')
    }
    setIsLoading(false);
    window.location.reload()
  }

  return (
    <Layout
      title={localization.approvals}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
          data={listData}
          isId={false}
          headers={Headers}
          detailList={approvalList && approvalList.resultSets}
          // onChange={(data) => updateApproval(data)}
          handleSendBack={handleSendBack}
          onChange={(data) => handleView(data)}
          srNo={approvalList?.from}
          pageCount={pageCount}
          onPageChange={onPageChange}
          isView = {true}
      />


      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'8'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        filterPreSalesListing
      />

        <ModalPop
            title={localization.updatedSuccessfully}
            show={isStatusSuccess}
            handleModalHide={closeSuccess}
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{localization.leadStatusupdatedsuccessfully}</h5>
            <Link to="#" onClick={closeSuccess} className="btn btn-transparent">
              {localization.continue}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        </ModalPop>

        <ModalPop
            title={
              actionData && actionData.action === 'reject'
                  ? localization.rejectConf
                  : localization.conf
            }
            show={isModal}
            handleModalHide={handleModalHide}
            actionData={actionData}
        >
          {actionData && actionData.action === 'reject' ? (
              <Fragment>
                <div className="modal-body">
                  <div className="text-center">
                    <h5>{localization.rejectApproval}</h5>
                    <div className="form-group">
                      {/* <TextAreaInput
                    type="text"
                    label={localization.addRemark}
                    required
                    isStarRequired={true}
                    handleChange={(e) => {
                      setRemarks({ ...setRemarks, remarks: e.target.value });
                    }}
                  /> */}
                      <ConstantInput
                          label={localization.addRemark}
                          required
                          isStarRequired={true}
                          type="text"
                          handleChange={(val) => {
                            setRemarks({ ...setRemarks, remarks: val });
                          }}
                      />
                    </div>
                    <Button
                        className="btn btn-primary"
                        onClick={handleContinue}
                        disabled={!remarks.remarks}
                      >
                        {localization.continue}{' '}
                        <img src="../images/arrow-right.png" alt="" />
                      </Button>
                  </div>
                </div>
                
          </Fragment>
        ) : (
          <Fragment>
            {successIconBox(localization.approveSuccess, handleModalHide)}
          </Fragment>
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.approveReject, handleRejectModalHide)}
      </ModalPop>
      <ModalPop
          title={localization.approvals}
          show={viewContract && Object.keys(viewDetails).length > 0}
          handleModalHide={handleApprovalViewHide}
      >

        <LeadDetail
            details={viewDetails}
            leadType={viewDetails?.lead_data?.lead_type_id ?? leadType}
        />
        <PostsaleDetail
            details={viewDetails?.postsale_data ?? []}
            leadTypeId={viewDetails?.lead_data?.lead_type_id ?? actionData?.actionObj?.lead_type_id ?? leadType}
        />
        {isValetContract && (
          <div className="modal-body pt-2 pb-2">
            <DropDownInput
              key={ownershipSelectKey}
              data={valetUsers}
              label="Select ownership user (Valet team)"
              required
              isStarRequired
              errorMsg={localization.isRequired || 'Required'}
              getIdValue={(val) => {
                setOwnershipUserId(val?.id || null);
                setOwnershipUserName(val?.value || '');
              }}
              controlledValue={ownershipUserId}
            />
          </div>
        )}
        <div>
          <button
            className="btn btn-block mr-3"
            disabled={isValetContract && !ownershipUserId}
            onClick={() => {updateApproval({action:"accept", actionObj:actionData?.actionObj})}}
          >
            Approval
          </button>
          <button className="btn btn-block mt-1" onClick={() => {updateApproval({action:"reject", actionObj:actionData?.actionObj})}}>Reject</button>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={showAcceptConfirm}
        handleModalHide={() => {
          setShowAcceptConfirm(false);
          setViewContract(true);
        }}
        modalSize="md"
      >
        <div className="modal-body" style={{ paddingTop: 8 }}>
          <div className="text-center mb-3">
            <h5 style={{ marginBottom: 6 }}>Confirm contract approval</h5>
            <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>
              Review invoice ownership and commercial details before approving.
            </p>
          </div>

          <div
            style={{
              maxWidth: 560,
              margin: '0 auto 16px',
              textAlign: 'left',
            }}
          >
            <div
              style={{
                background: 'linear-gradient(135deg, #f8f5ff 0%, #f3eefc 100%)',
                border: '1px solid #e4daf7',
                borderRadius: 10,
                padding: '14px 16px',
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: '#7c5cbf',
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                {isValetContract ? 'Invoice tagging' : 'Invoice will be tagged to'}
              </div>
              {isValetContract ? (
                <div style={{ display: 'grid', gap: 8 }}>
                  <div
                    style={{
                      background: '#fff',
                      borderRadius: 8,
                      padding: '10px 12px',
                      border: '1px solid #eee8f8',
                    }}
                  >
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                      1st invoice will be tagged to
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: '#1f2937' }}>
                      {valetL1Name || '—'}
                    </div>
                  </div>
                  <div
                    style={{
                      background: '#fff',
                      borderRadius: 8,
                      padding: '10px 12px',
                      border: '1px solid #eee8f8',
                    }}
                  >
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                      All next invoices will be tagged to
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 600, color: '#1f2937' }}>
                      {valetL2Name || '—'}
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    background: '#fff',
                    borderRadius: 8,
                    padding: '10px 12px',
                    border: '1px solid #eee8f8',
                  }}
                >
                  <div
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      background: '#6030be',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      fontSize: 14,
                      flexShrink: 0,
                    }}
                  >
                    {(invoiceOwnerName || '?').charAt(0).toUpperCase()}
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600, color: '#1f2937' }}>
                    {invoiceOwnerName || '—'}
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                background: 'linear-gradient(135deg, #f5f9ff 0%, #eef4fc 100%)',
                border: '1px solid #d7e4f5',
                borderRadius: 10,
                padding: '14px 16px',
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  fontSize: 11,
                  letterSpacing: 0.4,
                  textTransform: 'uppercase',
                  color: '#3b6ea5',
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Installation Person
              </div>
              <div
                style={{
                  background: '#fff',
                  borderRadius: 8,
                  padding: '10px 12px',
                  border: '1px solid #e3ecf7',
                  fontSize: 15,
                  fontWeight: 600,
                  color: '#1f2937',
                }}
              >
                {installationPersonName || '—'}
              </div>
            </div>

            {invoiceConfirmDetails.summaryRows.length > 0 && (
              <div
                style={{
                  background: '#fff',
                  border: '1px solid #ebe7f2',
                  borderRadius: 10,
                  padding: '12px 14px',
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    fontSize: 11,
                    letterSpacing: 0.4,
                    textTransform: 'uppercase',
                    color: '#6b7280',
                    fontWeight: 600,
                    marginBottom: 10,
                  }}
                >
                  Contract summary
                </div>
                <div style={{ display: 'grid', gap: 8 }}>
                  {invoiceConfirmDetails.summaryRows.map((row) => (
                    <div
                      key={row.label}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 12,
                        borderBottom: '1px solid #f3f4f6',
                        paddingBottom: 6,
                      }}
                    >
                      <span style={{ color: '#6b7280', fontSize: 13 }}>{row.label}</span>
                      <span
                        style={{
                          color: '#111827',
                          fontSize: 13,
                          fontWeight: 600,
                          textAlign: 'right',
                        }}
                      >
                        {row.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {invoiceConfirmDetails.sections.map((section) => (
              <div
                key={section.title}
                style={{
                  background: '#fcfcfd',
                  border: '1px solid #ebe7f2',
                  borderLeft: '3px solid #6030be',
                  borderRadius: 8,
                  padding: '12px 14px',
                  marginBottom: 12,
                }}
              >
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: '#374151',
                    marginBottom: 8,
                  }}
                >
                  {section.title}
                </div>
                <div style={{ display: 'grid', gap: 4 }}>
                  {section.lines.map((line, index) => (
                    <div
                      key={`${section.title}-${index}`}
                      style={{ fontSize: 13, color: '#4b5563' }}
                    >
                      {line}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div
            className="d-flex justify-content-center align-items-center"
            style={{ gap: '12px', flexWrap: 'wrap' }}
          >
            <Button
              className="btn btn-primary"
              style={{ width: 'auto', minWidth: 150 }}
              onClick={confirmAcceptApproval}
              disabled={isLoading}
            >
              Confirm Approval
            </Button>
            <Button
              className="btn btn-transparent"
              style={{ width: 'auto', minWidth: 110 }}
              onClick={() => {
                setShowAcceptConfirm(false);
                setViewContract(true);
              }}
              disabled={isLoading}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ModalPop>
      <ModalPop
        title={"Send back for modification"}
        show={modificationModal}
        handleModalHide={handleSendBackModalHide}
      >
        <Fragment>
          <div className="modal-body">
              <div className="col-md-12">
                <TextAreaInput
                  type="text"
                  rows={4}
                  className={`${
                    !formData.remark && "empty"
                  } inline-css scrollbar-styling`}
                  label={localization.remark}
                  value={formData?.remark}
                  inputValue={formData?.remark}
                  required
                  isStarRequired
                  errorMsg={localization.isRequired}
                  handleChange={(e) =>
                    setFormData({ ...formData, remark: e.target.value })
                  }
                />
              </div>
              <div className="d-flex">
                <FileUpload
                  id="attactment"
                  multiple="multiple"
                  accept=".pdf,.png,.jpg,.jpeg,.doc"
                  documentUploadUrl={documentUploadUrlPublic}
                  onChange={(val) =>
                    setFormData({ ...formData, attachment: val })
                  }
                >
                  <span className="btn btn-transparent">
                    {localization.attachment}
                  </span>
                </FileUpload>
              </div>
              <div className="d-flex" style={{ justifyContent: "end" }}>
                <Button
                  className="btn btn-primary btn-sm"
                  onClick={handleSubmit}
                  disabled={!formData.remark}
                >
                  {localization.submit}{" "}
                  <img src="../images/arrow-right.png" alt="" />
                </Button>
              </div>
          </div>
        </Fragment>
      </ModalPop>
    </Layout>
  );
};

ApprovalList.propTypes = {
  approvalList: PropTypes.any,
  getApprovalList: PropTypes.any,
  acceptApproval: PropTypes.any,
  rejectApproval: PropTypes.any,
  getSearchUser: PropTypes.func,
};

export default ApprovalList;
